import type { CourseAPIDetail, CourseAPIList, LimitOffsetSort } from '@jojotique/server'
import { fexios } from '@utils/fexios.ts'
import { getUrlWithPagination } from '@core/utils/url.ts'
import type { LoadingOptions } from '@service/services'

export const loadCourses = (pagination: LimitOffsetSort, opt?: LoadingOptions): Promise<CourseAPIList> => {
  const options: RequestInit = {}

  if (opt?.isAdmin) {
    options.credentials = 'include'
  }

  return new Promise<CourseAPIList>((resolve, reject) => {
    fexios
      .get<CourseAPIList>(getUrlWithPagination('/api/courses', pagination, { isAdmin: opt?.isAdmin }), options)
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors du chargement des cours')
      })
      .catch((error) => {
        reject(`Erreur lors du chargement des cours: ${error}`)
      })
  })
}

export const loadCourseWithSlug = (slug: string): Promise<CourseAPIDetail> => {
  return new Promise<CourseAPIDetail>((resolve, reject) => {
    fexios
      .get<CourseAPIDetail>(`/api/courses/${slug}`)
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors du chargement du cours')
      })
      .catch((error) => {
        reject(`Erreur lors du chargement du cours: ${error}`)
      })
  })
}
